import join from 'lodash/join';
export var joinArrayElements = function (values, separator) {
    if (separator === void 0) { separator = ''; }
    return join(values, separator);
};
